
export enum HostType {
  OFFICE = 'office',
  GSUITE = 'gsuite',
  WEB = 'web',
}